import { meetingBodyTypeValueLabels } from './value-labels.js';
export const meetingBodiesCube = {
    category: 'Meeting Bodies',
    description: 'Meeting body details including type, contact information, and meeting frequency.',
    label: 'Meeting Bodies',
    question: 'Which boards and committees exist, and how do I reach them?',
    bestFor: 'A directory of every board, commission, and committee — including type, contact, meeting cadence, and location.',
    tags: ['Directory', 'Contacts', 'Schedule'],
    measures: {
        'meeting_bodies.count': { label: 'Count', type: 'number' },
    },
    dimensions: {
        'meeting_bodies.name': { label: 'Name', type: 'string' },
        'meeting_bodies.type': {
            label: 'Type',
            type: 'string',
            valueLabels: meetingBodyTypeValueLabels,
        },
        'meeting_bodies.overview': { label: 'Overview', narrative: true, type: 'string' },
        'meeting_bodies.contact_name': { label: 'Contact Name', type: 'string' },
        'meeting_bodies.contact_email': { label: 'Contact Email', type: 'string' },
        'meeting_bodies.info': { label: 'Information', narrative: true, type: 'string' },
        'meeting_bodies.is_active': { label: 'Is Active', type: 'boolean' },
        'meeting_bodies.is_private': { label: 'Is Private', type: 'boolean' },
        'meeting_bodies.location': { label: 'Location', type: 'string' },
        'meeting_bodies.meeting_frequency': { label: 'Meeting Frequency', type: 'string' },
    },
    timeDimensions: {
        'meeting_bodies.created_at': { label: 'Created At', type: 'date' },
        'meeting_bodies.updated_at': { label: 'Updated At', type: 'date' },
    },
};
